import React from 'react';
import clsx from 'clsx';
import { Dropdown } from '../../../atoms';
import * as styles from '../select.styles';

/** @type {typeof import("..").SelectItem} */
const Item = ({ children, value, text, className, selected, ...props }) => {
  return (
    <Dropdown.Item
      lines={2}
      className={clsx(styles.components.item, className, {
        [styles.variants.selected]: selected,
      })}
      {...props}
    >
      {children}
    </Dropdown.Item>
  );
};

if (process.env.NODE_ENV !== 'production') {
  Item.displayName = 'Select.Item';
}

export default Item;
